import React from '../helpers/react';
import {CommentBox} from '../components/CommentBox.js';
import classList from 'ereader-core/dist/classList';
import {getHookClass} from '../helpers/cssHooks.js';

export const Step =  React.createClass({
    toggle : function(){
        this.props.toggle(this.props.id);
    },
  keyDownFullScreen: function(e){
    if(e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      e.currentTarget.click();
      return false;
    }
  },
    render : function(){
        let content = [];
        let classes = classList('step', getHookClass('Step'));

        if (this.props.opened) {
            content.push(this.props.html
                ? <div key="html" className="html step-html" dangerouslySetInnerHTML={{__html:this.props.html}} />
                : <img key="html" src={this.props.link} alt="" />);

            if(this.props.comments && this.props.show_comments) {
                content.push(
                    <CommentBox
                        key="comments"
                        id={this.props.id}
                        problemId={this.props.problemId}
                        comments={this.props.comments}
                        step={this.props.index}
                        solution_id={this.props.solution_id}
                        toggleComments={this.props.toggleComments}
                        postComment={this.props.postComment}
                        removeComment={this.props.removeComment}
                        opened={this.props.opened_comment}
                        getDef={this.props.getDef}
                        user={this.props.user}
                        show_fullscreen = {this.props.show_fullscreen} />
                );
            }
            classes.push('opened');
        }

            return (
            <section className={classes} data-id={this.props.id}>
                    <h4 className="step-header" tabIndex={"0"} onClick={this.toggle} role="button"  aria-pressed={this.props.opened} onKeyDown={(e)=>this.keyDownFullScreen(e)}>
                        <span className="step-num">{this.props.getDef('step.title',{index:this.props.index + 1}) + ' '}</span>
                        <span className="step-total">{this.props.getDef('step.title-total',{total:this.props.total})}</span>
                    </h4>
                <div className='content'>{content}</div>
            </section>
        );
    }
});

export default Step;


// WEBPACK FOOTER //
// ./src/components/Step.js